import { __read, __spreadArray } from "tslib";
import { from } from '../observable/from';
import { concatAll } from '../operators/concatAll';
import { operate } from '../util/lift';
export function concatWith() {
    var otherSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        otherSources[_i] = arguments[_i];
    }
    return operate(function (source, subscriber) {
        concatAll()(from(__spreadArray([source], __read(otherSources), false))).subscribe(subscriber);
    });
}
//# sourceMappingURL=concatWith.js.map